import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    request: {
        activeRowIndex: -1,
        visible: false,
        OrderID: null,
        method: null
    },
    response: {
        icon: "",
        orderDetails: {},
        loading: true,
    },
    error: null,
};

const orderDetailsSlice = createSlice({
    name: "orderDetails",
    initialState,
    reducers: {
        setRequestData: (state, action) => {
            const { field, value } = action.payload;
            state.request[field] = value;
        },
        setResponseData: (state, action) => {
            const { field, value } = action.payload;
            state.response[field] = value;
        },
        resetRequest: (state) => {
            state.request = initialState.request;
        },
        resetResponse: (state) => {
            state.response = initialState.response;
        },
        setError: (state, action) => {
            state.error = action.payload;
        },
    }
})

export const { setRequestData, setResponseData, resetRequest, resetResponse, setError } = orderDetailsSlice.actions;

export default orderDetailsSlice.reducer;
